/** @type {"horizontal"} */
export const HANDLE_MODE_HORIZONTAL = "horizontal";
/** @type {"all"} */
export const HANDLE_MODE_ALL = "all";
/** @type {"aspectRatio"} */
export const HANDLE_MODE_ASPECT_RATIO = "aspectRatio";
/** @type {"aspectRatioWRotation"} */
export const HANDLE_MODE_ASPECT_RATIO_W_ROTATION = "aspectRatioWRotation";

/**
 * Which resize and rotate handles the transformer draws.
 * @typedef {typeof HANDLE_MODE_HORIZONTAL
 *   | typeof HANDLE_MODE_ALL
 *   | typeof HANDLE_MODE_ASPECT_RATIO
 *   | typeof HANDLE_MODE_ASPECT_RATIO_W_ROTATION} HandleMode
 */
